import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="relative pt-32 pb-16 w-full flex items-center justify-center overflow-hidden">
      {/* BACKGROUND IMAGE */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{
          backgroundImage: "url('interiorhero.png')",
        }}
      />

      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-black/60" />

      {/* CONTENT */}
      <div className="relative z-10 text-center px-6 max-w-5xl">
        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
          Luxury Interior Design That Transforms Your Space
        </h1>

        <p className="text-gray-200 mt-5 text-base md:text-lg">
          We design modern, functional, and aesthetic interiors for homes and
          offices that reflect your lifestyle and personality.
        </p>

        <div className="mt-8 flex gap-4 justify-center flex-wrap">
          <Link
            to="https://webxsecure.in/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-xl font-medium transition"
          >
            Get Free Consultation
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
